import { UserRole } from '@modules/core/types';
import { Permissions } from '@modules/permissions/types';

export const SANFORD_STAGING = {
  [UserRole.ADMINISTRATOR]: [
    Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
    Permissions.GENETIC_COUNSELING,
    Permissions.GENETIC_COUNSELING__CREATE,
    Permissions.CAN_VIEW_PHI,
    Permissions.CAMPAIGN_TRACKING,
  ],
  [UserRole.EXECUTIVE]: [Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3, Permissions.CAMPAIGN_TRACKING],
  [UserRole.MEMBER_LIMITED_PHI]: [Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3, Permissions.CAMPAIGN_TRACKING],
  [UserRole.MEMBER]: [
    Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
    Permissions.GENETIC_COUNSELING,
    Permissions.GENETIC_COUNSELING__CREATE,
    Permissions.CAN_VIEW_PHI,
    Permissions.CAMPAIGN_TRACKING,
  ],
};
